import type { DocumentDownloadLogFilters } from '../../api/downloadLogs';

/**
 * Shallow value comparison — `DocumentDownloadLogFilters` is a flat object of
 * primitives, so this is enough to tell "nothing actually changed" apart from
 * "a new object with the same values was created" (e.g. a filter input fires
 * onBlur without its value changing). Guards against refetching the list when
 * no field's value actually changed.
 */
export const areFiltersEqual = (a: DocumentDownloadLogFilters, b: DocumentDownloadLogFilters): boolean => {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]) as Set<keyof DocumentDownloadLogFilters>;
  return [...keys].every(key => a[key] === b[key]);
};
